import React, { type FC } from 'react';

interface TabbedNavigationProps {
  className?: string;
  label: string;
  isActive: boolean;
  onClick: () => void;
}

const TabbedNavigation: FC<TabbedNavigationProps> = ({
  className,
  label,
  isActive,
  onClick,
}) => {
  return (
    <button
      type="button"
      className={`flex items-center justify-center whitespace-nowrap border-b-[3px] pb-6 text-lg font-medium leading-6 ${
        isActive
          ? 'border-leland-primary text-leland-gray-dark'
          : 'border-transparent text-leland-gray-extra-light'
      } ${className}`}
      onClick={onClick}
    >
      {label}
    </button>
  );
};

export default TabbedNavigation;
